export const API_BASE = 'https://server.multisellerpro.com';

export const MARKETPLACE_LOGOS = {
    amazon: '/logos/amazon.png',
    walmart: '/logos/walmart.png',
    ebay: '/logos/ebay.png'
};

export const SUPPLIERS = [
    { 'id': 'csv', 'name': 'CSV', 'logo': '/logos/csv.png', 'support_live_scan': false },
    { 'id': 'academy', 'name': 'Academy', 'logo': '/logos/academy.png', 'support_live_scan': true },
    { 'id': 'acehardware', 'name': 'Acehardware', 'logo': '/logos/acehardware.png', 'support_live_scan': true },
    { 'id': 'acmetools', 'name': 'Acmetools', 'logo': '/logos/acmetools.png', 'support_live_scan': true },
    { 'id': 'aerosoles', 'name': 'Aerosoles', 'logo': '/logos/aerosoles.png', 'support_live_scan': true },
    { 'id': 'altomusic', 'name': 'Altomusic', 'logo': '/logos/altomusic.png', 'support_live_scan': true },
    { 'id': 'amazon', 'name': 'Amazon', 'logo': '/logos/amazon.png', 'support_live_scan': true },
    { 'id': 'annscottage', 'name': 'Annscottage', 'logo': '/logos/annscottage.png', 'support_live_scan': true },
    { 'id': 'bangalla', 'name': 'Bangalla', 'logo': '/logos/bangalla.png', 'support_live_scan': true },
    { 'id': 'barnesandnoble', 'name': 'Barnesandnoble', 'logo': '/logos/barnesandnoble.png', 'support_live_scan': true },
    { 'id': 'bathandbodyworks', 'name': 'Bathandbodyworks', 'logo': '/logos/bathandbodyworks.png', 'support_live_scan': true },
    { 'id': 'bbtoystore', 'name': 'Bbtoystore', 'logo': '/logos/bbtoystore.png', 'support_live_scan': true },
    { 'id': 'beautylish', 'name': 'Beautylish', 'logo': '/logos/beautylish.png', 'support_live_scan': true },
    { 'id': 'bedbathandbeyond', 'name': 'Bedbathandbeyond', 'logo': '/logos/bedbathandbeyond.png', 'support_live_scan': true },
    { 'id': 'belk', 'name': 'Belk', 'logo': '/logos/belk.png', 'support_live_scan': true },
    { 'id': 'bestbuy', 'name': 'Bestbuy', 'logo': '/logos/bestbuy.png', 'support_live_scan': true },
    { 'id': 'bhphotovideo', 'name': 'Bhphotovideo', 'logo': '/logos/bhphotovideo.png', 'support_live_scan': true },
    { 'id': 'bjs', 'name': 'Bjs', 'logo': '/logos/bjs.png', 'support_live_scan': true },
    { 'id': 'bloomingdales', 'name': 'Bloomingdales', 'logo': '/logos/bloomingdales.png', 'support_live_scan': true },
    { 'id': 'bonton', 'name': 'Bonton', 'logo': '/logos/bonton.png', 'support_live_scan': true },
    { 'id': 'boscovs', 'name': 'Boscovs', 'logo': '/logos/boscovs.png', 'support_live_scan': true },
    { 'id': 'buydig', 'name': 'Buydig', 'logo': '/logos/buydig.png', 'support_live_scan': true },
    { 'id': 'caretobeauty', 'name': 'Caretobeauty', 'logo': '/logos/caretobeauty.png', 'support_live_scan': true },
    { 'id': 'chewy', 'name': 'Chewy', 'logo': '/logos/chewy.png', 'support_live_scan': true },
    { 'id': 'cvs', 'name': 'Cvs', 'logo': '/logos/cvs.png', 'support_live_scan': true },
    { 'id': 'dermstore', 'name': 'Dermstore', 'logo': '/logos/dermstore.png', 'support_live_scan': true },
    { 'id': 'dickssportinggoods', 'name': 'Dickssportinggoods', 'logo': '/logos/dickssportinggoods.png', 'support_live_scan': true },
    { 'id': 'dillards', 'name': 'Dillards', 'logo': '/logos/dillards.png', 'support_live_scan': true },
    { 'id': 'disneystore', 'name': 'Disneystore', 'logo': '/logos/disneystore.png', 'support_live_scan': true },
    { 'id': 'dsw', 'name': 'Dsw', 'logo': '/logos/dsw.png', 'support_live_scan': true },
    { 'id': 'ecosmetorium', 'name': 'Ecosmetorium', 'logo': '/logos/ecosmetorium.png', 'support_live_scan': true },
    { 'id': 'everythingkitchens', 'name': 'Everythingkitchens', 'logo': '/logos/everythingkitchens.png', 'support_live_scan': true },
    { 'id': 'famousfootwear', 'name': 'Famousfootwear', 'logo': '/logos/famousfootwear.png', 'support_live_scan': true },
    { 'id': 'farmandfleet', 'name': 'Farmandfleet', 'logo': '/logos/farmandfleet.png', 'support_live_scan': true },
    { 'id': 'fatbraintoys', 'name': 'Fatbraintoys', 'logo': '/logos/fatbraintoys.png', 'support_live_scan': true },
    { 'id': 'fivebelow', 'name': 'Fivebelow', 'logo': '/logos/fivebelow.png', 'support_live_scan': true },
    { 'id': 'fleetfarm', 'name': 'Fleetfarm', 'logo': '/logos/fleetfarm.png', 'support_live_scan': true },
    { 'id': 'footsmart', 'name': 'Footsmart', 'logo': '/logos/footsmart.png', 'support_live_scan': true },
    { 'id': 'frontiercoop', 'name': 'Frontiercoop', 'logo': '/logos/frontiercoop.png', 'support_live_scan': true },
    { 'id': 'fye', 'name': 'Fye', 'logo': '/logos/fye.png', 'support_live_scan': true },
    { 'id': 'gamestop', 'name': 'Gamestop', 'logo': '/logos/gamestop.png', 'support_live_scan': true },
    { 'id': 'globalgolf', 'name': 'Globalgolf', 'logo': '/logos/globalgolf.png', 'support_live_scan': true },
    { 'id': 'gnc', 'name': 'Gnc', 'logo': '/logos/gnc.png', 'support_live_scan': true },
    { 'id': 'hartmannvariety', 'name': 'Hartmannvariety', 'logo': '/logos/hartmannvariety.png', 'support_live_scan': true },
    { 'id': 'healthypets', 'name': 'Healthypets', 'logo': '/logos/healthypets.png', 'support_live_scan': true },
    { 'id': 'hearthsong', 'name': 'Hearthsong', 'logo': '/logos/hearthsong.png', 'support_live_scan': true },
    { 'id': 'herbspro', 'name': 'Herbspro', 'logo': '/logos/herbspro.png', 'support_live_scan': true },
    { 'id': 'homedepot', 'name': 'Homedepot', 'logo': '/logos/homedepot.png', 'support_live_scan': true },
    { 'id': 'iherb', 'name': 'Iherb', 'logo': '/logos/iherb.png', 'support_live_scan': true },
    { 'id': 'jcpenney', 'name': 'Jcpenney', 'logo': '/logos/jcpenney.png', 'support_live_scan': true },
    { 'id': 'jefferspet', 'name': 'Jefferspet', 'logo': '/logos/jefferspet.png', 'support_live_scan': true },
    { 'id': 'keepsakequilting', 'name': 'Keepsakequilting', 'logo': '/logos/keepsakequilting.png', 'support_live_scan': true },
    { 'id': 'kohls', 'name': 'Kohls', 'logo': '/logos/kohls.png', 'support_live_scan': true },
    { 'id': 'kroger', 'name': 'Kroger', 'logo': '/logos/kroger.png', 'support_live_scan': true },
    { 'id': 'lowes', 'name': 'Lowes', 'logo': '/logos/lowes.png', 'support_live_scan': true },
    { 'id': 'luggagepros', 'name': 'Luggagepros', 'logo': '/logos/luggagepros.png', 'support_live_scan': true },
    { 'id': 'macys', 'name': 'Macys', 'logo': '/logos/macys.png', 'support_live_scan': true },
    { 'id': 'meijer', 'name': 'Meijer', 'logo': '/logos/meijer.png', 'support_live_scan': true },
    { 'id': 'michaels', 'name': 'Michaels', 'logo': '/logos/michaels.png', 'support_live_scan': true },
    { 'id': 'microcenter', 'name': 'Microcenter', 'logo': '/logos/microcenter.png', 'support_live_scan': true },
    { 'id': 'mytoolstore', 'name': 'Mytoolstore', 'logo': '/logos/mytoolstore.png', 'support_live_scan': true },
    { 'id': 'nike', 'name': 'Nike', 'logo': '/logos/nike.png', 'support_live_scan': true },
    { 'id': 'officedepot', 'name': 'Officedepot', 'logo': '/logos/officedepot.png', 'support_live_scan': true },
    { 'id': 'officesupply', 'name': 'Officesupply', 'logo': '/logos/officesupply.png', 'support_live_scan': true },
    { 'id': 'opentip', 'name': 'Opentip', 'logo': '/logos/opentip.png', 'support_live_scan': true },
    { 'id': 'packershoes', 'name': 'Packershoes', 'logo': '/logos/packershoes.png', 'support_live_scan': true },
    { 'id': 'partsexpress', 'name': 'Partsexpress', 'logo': '/logos/partsexpress.png', 'support_live_scan': true },
    { 'id': 'pcrichard', 'name': 'Pcrichard', 'logo': '/logos/pcrichard.png', 'support_live_scan': true },
    { 'id': 'peltzshoes', 'name': 'Peltzshoes', 'logo': '/logos/peltzshoes.png', 'support_live_scan': true },
    { 'id': 'petsmart', 'name': 'Petsmart', 'logo': '/logos/petsmart.png', 'support_live_scan': true },
    { 'id': 'pinkcherry', 'name': 'Pinkcherry', 'logo': '/logos/pinkcherry.png', 'support_live_scan': true },
    { 'id': 'pureformulas', 'name': 'Pureformulas', 'logo': '/logos/pureformulas.png', 'support_live_scan': true },
    { 'id': 'rarebeauty', 'name': 'Rarebeauty', 'logo': '/logos/rarebeauty.png', 'support_live_scan': true },
    { 'id': 'rei', 'name': 'Rei', 'logo': '/logos/rei.png', 'support_live_scan': true },
    { 'id': 'rinovelty', 'name': 'Rinovelty', 'logo': '/logos/rinovelty.png', 'support_live_scan': true },
    { 'id': 'roadrunnersports', 'name': 'Roadrunnersports', 'logo': '/logos/roadrunnersports.png', 'support_live_scan': true },
    { 'id': 'ruralking', 'name': 'Ruralking', 'logo': '/logos/ruralking.png', 'support_live_scan': true },
    { 'id': 'samsclub', 'name': 'Samsclub', 'logo': '/logos/samsclub.png', 'support_live_scan': true },
    { 'id': 'sephora', 'name': 'Sephora', 'logo': '/logos/sephora.png', 'support_live_scan': true },
    { 'id': 'target', 'name': 'Target', 'logo': '/logos/target.png', 'support_live_scan': true },
    { 'id': 'truevalue', 'name': 'Truevalue', 'logo': '/logos/truevalue.png', 'support_live_scan': true },
    { 'id': 'underarmour', 'name': 'Underarmour', 'logo': '/logos/underarmour.png', 'support_live_scan': true },
    { 'id': 'vitacost', 'name': 'Vitacost', 'logo': '/logos/vitacost.png', 'support_live_scan': true },
    { 'id': 'vitaminlife', 'name': 'Vitaminlife', 'logo': '/logos/vitaminlife.png', 'support_live_scan': true },
    { 'id': 'walgreens', 'name': 'Walgreens', 'logo': '/logos/walgreens.png', 'support_live_scan': true },
    { 'id': 'walmart', 'name': 'Walmart', 'logo': '/logos/walmart.png', 'support_live_scan': true },
    { 'id': 'webstaurantstore', 'name': 'Webstaurantstore', 'logo': '/logos/webstaurantstore.png', 'support_live_scan': true },
    { 'id': 'yankeecandle', 'name': 'Yankeecandle', 'logo': '/logos/yankeecandle.png', 'support_live_scan': true },
    { 'id': 'zappos', 'name': 'Zappos', 'logo': '/logos/zappos.png', 'support_live_scan': true },
    { 'id': 'zoro', 'name': 'Zoro', 'logo': '/logos/zoro.png', 'support_live_scan': true },
    { 'id': '1000bulbs', 'name': '1000bulbs', 'logo': '/logos/1000bulbs.png', 'support_live_scan': true },
    { 'id': 'dkhardware', 'name': 'Dkhardware', 'logo': '/logos/dkhardware.png', 'support_live_scan': false },
    { 'id': 'dollargeneral', 'name': 'Dollargeneral', 'logo': '/logos/dollargeneral.png', 'support_live_scan': false },
    { 'id': 'ebay', 'name': 'Ebay', 'logo': '/logos/ebay.png', 'support_live_scan': false },
    { 'id': 'heb', 'name': 'Heb', 'logo': '/logos/heb.png', 'support_live_scan': false },
    { 'id': 'hyvee', 'name': 'Hyvee', 'logo': '/logos/hyvee.png', 'support_live_scan': false },
    { 'id': 'myotcstore', 'name': 'Myotcstore', 'logo': '/logos/myotcstore.png', 'support_live_scan': false },
    { 'id': 'shoprite', 'name': 'Shoprite', 'logo': '/logos/shoprite.png', 'support_live_scan': false },
    { 'id': 'vitaminshoppe', 'name': 'Vitaminshoppe', 'logo': '/logos/vitaminshoppe.png', 'support_live_scan': false }
];

export const getSupplierLogo = (supplierName) => {
    if (!supplierName) {
        return "checking.gif"
    }
    const supplier = SUPPLIERS.find(s =>
        s.name.toLowerCase() === supplierName.toLowerCase()
    );
    return supplier?.logo || null;
};

// Cashback and Gift Card Sites - prioritized list
export const CASHBACK_SITES = [
    {
        name: 'GiftCardWiki',
        logo: 'https://www.giftcardwiki.com/assets/images/logo_trans.png',
        url: 'https://www.giftcardwiki.com/gift-cards/{supplier}',
        type: 'giftcard'
    },
    {
        name: 'CardBear',
        logo: 'https://www.cardbear.com/favicon.ico',
        url: 'https://www.cardbear.com/',
        type: 'giftcard'
    },
    {
        name: 'ArbitrageCard',
        logo: 'https://arbitragecard.com/favicon.ico',
        url: 'https://arbitragecard.com/giftcards/',
        type: 'giftcard'
    },
    {
        name: 'Rakuten',
        logo: 'https://static.rakuten.com/static/images/favicons-r/v1/icon-180x180.png',
        url: 'https://www.rakuten.com/search?term={supplier}&type=suggest',
        type: 'cashback'
    },
    {
        name: 'BeFrugal',
        logo: 'https://www.befrugal.com/favicon.ico',
        url: 'https://www.befrugal.com/store/{supplier}/',
        type: 'cashback'
    },
    {
        name: 'TopCashback',
        logo: 'https://www.topcashback.com/favicon.ico',
        url: 'https://www.topcashback.com/search/merchants/?s={supplier}',
        type: 'cashback'
    },
    {
        name: 'CardCash',
        logo: 'https://cdn.cardcash.com/images/favicons/cardcash.ico',
        url: 'https://www.cardcash.com/buy-gift-cards/',
        type: 'giftcard'
    },
    {
        name: 'Swagbucks',
        logo: 'https://www.swagbucks.com/favicon.ico',
        url: 'https://www.swagbucks.com/?q={supplier}',
        type: 'cashback'
    }
];